/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2025 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

import React from 'react';
import pkceChallenge from 'pkce-challenge';

const SsoLogin = (): JSX.Element | null => {
  const ssoEnabled = process.env.REACT_APP_ONYX_SSO_ENABLED === 'true';
  const loginUserSso = async (e: any): Promise<void> => {
    e.preventDefault();
    const challenge = await pkceChallenge();
    //store the verifier in session for retrieval after the next step
    sessionStorage.setItem('verifier', challenge.code_verifier);
    window.location.assign(
      process.env.REACT_APP_ONYX_HRD_ENDPOINT! +
        process.env.REACT_APP_ONYX_OAUTH_CALLBACK_URI! +
        `&code_challenge=${challenge.code_challenge}&code_challenge_method=S256`,
    );
  };

  if (ssoEnabled) {
    return (
      <>
        <div className="form-item d-flex flex-row align-items-center">
          <hr className="w-100" />
          <span className="mx-3">or</span>
          <hr className="w-100" />
        </div>
        <button
          type="submit"
          data-cy="LP-Login-Button"
          className="Loginbutton button form-item d-flex align-items-center justify-content-center text-white"
          onClick={loginUserSso}>
          Login with SSO
        </button>
      </>
    );
  } else {
    return null;
  }
};

export default SsoLogin;
